module.exports = __webpack_public_path__ + "img/logo@2x.7b500f82.png";